export { default } from "./GoogleReCAPTCHA";



// WEBPACK FOOTER //
// ./src/design-system/atoms/GoogleReCAPTCHA/index.jsx